import { useMemo } from "react";

const useYearMonthDates = (year = new Date().getFullYear()) =>
  useMemo(
    () => new Array(12).fill(null).map((_, month) => new Date(year, month, 1)),
    [year],
  );

export default useYearMonthDates;
